<template>
        <div>
            <div class="ux-filter-records filter-records">
            <div class='content-list' style="height:auto">
              <el-table
                empty-text="暂无数据"
                class="table ux-dark-el-table"
                :data="tableData"
                max-height="365"
                element-loading-spinner="el-icon-loading">
                  <el-table-column v-for="(props, i) in tableHeader" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div v-if="activeName === 'Order' && props.prop === 'guid'" class="text">{{ scope.row.copNo || '--' }}</div>
                      <div v-if="props.prop === 'returnStatus'" class="text">{{ setReturnStatus(scope.row.returnStatus) || '--' }}</div>
                      <div v-else class="text">{{ scope.row[props.prop] || '--' }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label='操作' align="center">
                    <template slot-scope="scope">
                      <div class="blue" @click="toDetail(scope.row)">详情</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                @current-change="currentChange"
              />
              <pagination @currentChange="currentChange" @sizeChange="sizeChange"/>
            </div>
          </div>
        </div>
</template>
<script>
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
const {mapState, mapMutations} = require('vuex')
export default {
  components: {pagination},
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    guid: {
      type: String,
      default: ''
    },
    activeName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableHeader: [
        {
          prop: 'guid',
          label: '系统唯一序号'
        },
        {
          prop: 'appTypeStr',
          label: '报送类型'
        },
        {
          prop: 'appStatusStr',
          label: '报送状态'
        },
        {
          prop: 'returnStatus',
          label: '回执状态'
        },
        {
          prop: 'appTime',
          label: '报送时间'
        },
        {
          prop: 'returnTime',
          label: '回执时间'
        },
        {
          prop: 'returnInfo',
          label: '回执信息'
        }
      ],
      tableData: [],
      url: '',
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      appStatusObj: {
        '1': '暂存',
        '2': '申报'
      },
      appTypeObj: {
        '1': '新增',
        '2': '变更',
        '3': '删除'
      }
    }
  },
  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },
  watch: {
    guid: {
      handler (v) {
        // console.log('guid', v)
      },
      immediate: true
    },
    activeName: {
      handler (v) {
        this.page.current = 1
        this.page.size = 10
        this.getActiveName(v)
      },
      immediate: true
    },
    searchDate: function (n) {
      this.getlist()
    }
  },
  created () {
  },
  // beforeDestroy () {
  //   this.$store.dispatch('getisShowDetail', 1)
  //   this.$store.dispatch('getShowDetail', {})
  // },
  methods: {
    setReturnStatus (returnStatus) {
      switch (returnStatus) {
        case '0':
          return '成功'
        case '1':
          return '失败'
        case '2':
          return '报文交验通过'
      }
    },
    ...mapMutations({}),
    getlist () {
      let sendData = {
        'searchDate': this.searchDate,
        'companyNo': this.info.companyNo,
        'companyName': this.info.companyName,
        'pageNum': this.page.current,
        'pageSize': this.page.size,
        // customerNo: this.info.customerNo
        customerNo: this.info.customerNo
        // customerNo: 'AAAC'
      }
      const getActiveName = this.activeName
      if (getActiveName === 'Order') {
        sendData['copNo'] = this.guid
      } else {
        sendData['guid'] = this.guid
      }
      this.$ajax({
        method: 'post',
        url: this.url,
        data: sendData
      }).then(res => {
        if (res) {
          const dataInfo = res.data || {}
          let getList = dataInfo.records || []
          getList.map(item => {
            item.appStatusStr = this.appStatusObj[item.appStatus + '']
            item.appTypeStr = this.appTypeObj[item.appType + '']
          })
          this.tableData = getList
          this.page.total = dataInfo.total || 0
        } else {
          this.tableData = []
          this.page.total = 0
        }
      })
    },
    toDetail (row) {
      let detailObj = row || {}
      detailObj.activeName = this.activeName
      detailObj.info = this.info
      this.$store.dispatch('getisShowDetail', 3)
      this.$store.dispatch('getShowDetail', detailObj)
    },
    currentChange (e) {
      this.page.current = e
      this.getlist()
    },
    sizeChange (e) {
      this.page.current = 1
      this.page.size = e
      this.getlist()
    },
    getActiveName (activeName) {
      switch (activeName) {
        case 'Order':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationOrderList}`
          break
        case 'Receipt':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationReceipts}`
          break
        case 'Waybill':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationLogistics}`
          break
        case 'Manifest':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationClearance}`
          break
        case 'ListTotal':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationClearanceTotal}`
          break
        case 'DeclarationNote':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationArrival}`
          break
        case 'DeclarationDeparture':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationDeparture}`
          break
        case 'summarySheet':
          this.url = `${apiPath.bigData.search.bg.tabs.getDeclarationSummaryApply}`
          break
      }
      this.getlist()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/components/tableLit.vue